module.exports = __webpack_public_path__ + "static/media/ImageHome_elBanner982162_1920_530737.6810bc85.jpg";